import { render, staticRenderFns } from "./DataFastEdit.vue?vue&type=template&id=278a6a9a&"
import script from "./DataFastEdit.vue?vue&type=script&lang=js&"
export * from "./DataFastEdit.vue?vue&type=script&lang=js&"
import style0 from "./DataFastEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports